/**
 * Validates that MOQ is divisible by increment.
 * Returns null when input is invalid (non-integer or increment <= 0) — these
 * states indicate "field not yet set" during editing; the parent form is
 * responsible for final validation on submit.
 *
 * @returns null when valid (or input invalid), error message string otherwise.
 */
export function validateMoqDivisibleByIncrement(
  moq: number,
  increment: number,
): string | null {
  if (!Number.isInteger(moq) || !Number.isInteger(increment)) return null;
  if (increment <= 0) return null;
  if (moq % increment !== 0) {
    return `Minimum order quantity (${moq}) must be divisible by order increment (${increment})`;
  }
  return null;
}

export function validateBreaksAboveMoq(
  breaks: ReadonlyArray<{ min_quantity: number }>,
  moq: number,
): number[] {
  return breaks
    .map((b, i) => (b.min_quantity < moq ? i : -1))
    .filter((i) => i !== -1);
}

export function detectDuplicateMinQuantities(
  breaks: ReadonlyArray<{ min_quantity: number }>,
): number[] {
  const counts = new Map<number, number[]>();
  breaks.forEach((b, i) => {
    const idxs = counts.get(b.min_quantity) ?? [];
    idxs.push(i);
    counts.set(b.min_quantity, idxs);
  });
  return Array.from(counts.values())
    .filter((idxs) => idxs.length > 1)
    .flat()
    .sort((a, b) => a - b);
}
